<template>

    <div class="p-15">
        <v-notice v-if="!templates.length" size="sm" message="No Templates" />
        <div v-else class="template-items">
            <div class="template-item" v-for="t in templates" :key="t.id" :title="t.name" @click="selectTemplate(t)">
                <span>{{ t.name | truncate(30) }}</span>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .template-items {
        display: grid;
        gap: 10px;
        grid-template-columns: 1fr 1fr;
        .template-item {
            @include font-medium(13px);
            align-items: center;
            background: #fff;
            border-radius: 5px;
            border: 1px solid $color-rule;
            cursor: pointer;
            display: flex;
            height: 100px;
            justify-content: center;
            padding: 30px;
            position: relative;
            text-align: center;
            transition: border-color .3s;
            &:hover {
                border-color: $color-text;
            }
        }
    }

</style>

<script>

export default {

    computed: {

        templates() {
            return this.$store.getters['builder/templates'];
        },

    },

    methods: {

        selectTemplate(template) {
            this.$store.commit('builder/setSelectedTemplate', template);
            this.$store.commit('builder/setSelectedModal', 'template');
        },

    },

}

</script>